import { useParams, Link } from 'react-router-dom';
import { FaArrowLeft, FaInfoCircle, FaUser } from 'react-icons/fa';
import axios from '../api/axios';
import React, { useState, useEffect } from 'react';

export default function TitulareDetail() {
    const { id } = useParams();
    const [titulare, setTitulare] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchTitulare = async () => {
            setIsLoading(true);
            try {
                const response = await axios.get(`/titulares/${id}`);
                setTitulare(response.data);
            } catch (err) {
                setError('Error al cargar los detalles del titular. Por favor, intente de nuevo.');
                console.error('Error fetching titular details:', err);
            } finally {
                setIsLoading(false);
            }
        };

        fetchTitulare();
    }, [id]);

    if (isLoading) {
        return (
            <div className="flex justify-center items-center h-screen">
                <div className="animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-blue-500"></div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="container mx-auto px-4 py-8">
                <div className="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 rounded" role="alert">
                    <p className="font-bold">Error</p>
                    <p>{error}</p>
                </div>
            </div>
        );
    }

    if (!titulare) {
        return (
            <div className="container mx-auto px-4 py-8">
                <div className="bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-4 rounded" role="alert">
                    <p className="font-bold">Advertencia</p>
                    <p>No se encontró el titular</p>
                </div>
            </div>
        );
    }

    return (
        <div className="container mx-auto px-4 py-8">
            <Link to="/home/titulares" className="inline-flex items-center text-blue-600 hover:text-blue-800 mb-6 transition-colors duration-200">
                <FaArrowLeft className="mr-2" /> Volver a la lista de titulares
            </Link>
            <div className="bg-white shadow-2xl rounded-lg overflow-hidden">
                <div className="bg-gradient-to-r from-blue-600 to-blue-800 p-6 text-white">
                    <h2 className="text-3xl font-bold flex items-center">
                        <FaUser className="mr-4 text-4xl" />
                        Titular #{titulare.id}
                    </h2>
                </div>
                <div className="p-6 grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div className="bg-gray-50 p-6 rounded-lg shadow-md transition-all duration-300 hover:shadow-lg">
                        <h3 className="text-xl font-semibold mb-4 text-gray-800 flex items-center">
                            <FaInfoCircle className="mr-2 text-yellow-600" /> Tercero ID
                        </h3>
                        <p className="text-gray-700">{titulare.terceroId || 'No disponible'}</p>
                    </div>
                    <div className="bg-gray-50 p-6 rounded-lg shadow-md transition-all duration-300 hover:shadow-lg">
                        <h3 className="text-xl font-semibold mb-4 text-gray-800 flex items-center">
                            <FaInfoCircle className="mr-2 text-yellow-600" /> Fecha
                        </h3>
                        <p className="text-gray-700">{titulare.fecha || 'No disponible'}</p>
                    </div>
                    <div className="bg-gray-50 p-6 rounded-lg shadow-md transition-all duration-300 hover:shadow-lg">
                        <h3 className="text-xl font-semibold mb-4 text-gray-800 flex items-center">
                            <FaInfoCircle className="mr-2 text-yellow-600" /> Observaciones
                        </h3>
                        <p className="text-gray-700">{titulare.observaciones || 'No disponible'}</p>
                    </div>
                    <div className="bg-gray-50 p-6 rounded-lg shadow-md transition-all duration-300 hover:shadow-lg">
                        <h3 className="text-xl font-semibold mb-4 text-gray-800 flex items-center">
                            <FaInfoCircle className="mr-2 text-yellow-600" /> Sepultura ID
                        </h3>
                        <p className="text-gray-700">{titulare.sepulturaId || 'No disponible'}</p>
                    </div>
                </div>
            </div>
        </div>
    );
}

/*
import { useParams, Link } from 'react-router-dom';
import { FaArrowLeft, FaInfoCircle, FaUser } from 'react-icons/fa';
import axios from '../api/axios';
import React, { useState, useEffect } from 'react';

export default function TitulareDetail() {
    const { id } = useParams();
    const [titulare, setTitulare] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchTitulare = async () => {
            setIsLoading(true);
            try {
                const response = await axios.get(`/titulares/${id}`);
                setTitulare(response.data);
            } catch (err) {
                setError('Error al cargar los detalles del titular. Por favor, intente de nuevo.');
                console.error('Error fetching titular details:', err);
            } finally {
                setIsLoading(false);
            }
        };

        fetchTitulare();
    }, [id]);

    if (isLoading) {
        return (
            <div className="flex justify-center items-center h-screen">
                <div className="animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-blue-500"></div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="container mx-auto px-4 py-8">
                <div className="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 rounded" role="alert">
                    <p className="font-bold">Error</p>
                    <p>{error}</p>
                </div>
            </div>
        );
    }

    if (!titulare) {
        return (
            <div className="container mx-auto px-4 py-8">
                <div className="bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-4 rounded" role="alert">
                    <p className="font-bold">Advertencia</p>
                    <p>No se encontró el titular</p>
                </div>
            </div>
        );
    }

    return (
        <div className="container mx-auto px-4 py-8">
            <Link to="/home/titulares" className="inline-flex items-center text-blue-600 hover:text-blue-800 mb-6 transition-colors duration-200">
                <FaArrowLeft className="mr-2" /> Volver a la lista de titulares
            </Link>
            <div className="bg-white shadow-2xl rounded-lg overflow-hidden">
                <div className="bg-gradient-to-r from-blue-600 to-blue-800 p-6 text-white">
                    <h2 className="text-3xl font-bold flex items-center">
                        <FaUser className="mr-4 text-4xl" />
                        Titular #{titulare.id}
                    </h2>
                </div>
                <div className="p-6 space-y-6">
                    <div className="bg-gray-50 p-6 rounded-lg shadow-md transition-all duration-300 hover:shadow-lg">
                        <h3 className="text-xl font-semibold mb-4 text-gray-800 flex items-center">
                            <FaInfoCircle className="mr-2 text-yellow-600" /> Tercero ID
                        </h3>
                        <p className="text-gray-700">{titulare.terceroId || 'No disponible'}</p>
                    </div>
                    <div className="bg-gray-50 p-6 rounded-lg shadow-md transition-all duration-300 hover:shadow-lg">
                        <h3 className="text-xl font-semibold mb-4 text-gray-800 flex items-center">
                            <FaInfoCircle className="mr-2 text-yellow-600" /> Fecha
                        </h3>
                        <p className="text-gray-700">{titulare.fecha || 'No disponible'}</p>
                    </div>
                    <div className="bg-gray-50 p-6 rounded-lg shadow-md transition-all duration-300 hover:shadow-lg">
                        <h3 className="text-xl font-semibold mb-4 text-gray-800 flex items-center">
                            <FaInfoCircle className="mr-2 text-yellow-600" /> Observaciones
                        </h3>
                        <p className="text-gray-700">{titulare.observaciones || 'No disponible'}</p>
                    </div>
                    <div className="bg-gray-50 p-6 rounded-lg shadow-md transition-all duration-300 hover:shadow-lg">
                        <h3 className="text-xl font-semibold mb-4 text-gray-800 flex items-center">
                            <FaInfoCircle className="mr-2 text-yellow-600" /> Sepultura ID
                        </h3>
                        <p className="text-gray-700">{titulare.sepulturaId || 'No disponible'}</p>
                    </div>
                </div>
            </div>
        </div>
    );
}
*/